/** Fält som kan användas när användare söks (namn, e-post, RSID, anställnings-ID). */
export type UserSearchFields = {
  first_name?: string | null;
  last_name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  rsid?: string | null;
  employee_id?: string | null;
  employeeId?: string | null;
  current_vehicle_registration?: string | null;
  organization_name?: string | null;
};

export function userEmploymentId(user: UserSearchFields): string {
  return String(user.rsid || user.employee_id || user.employeeId || '').trim();
}

export function userMatchesSearch(user: UserSearchFields, query: string, extra: string[] = []): boolean {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const first = String(user.first_name ?? user.firstName ?? '').toLowerCase();
  const last = String(user.last_name ?? user.lastName ?? '').toLowerCase();
  const haystack = [
    first,
    last,
    `${first} ${last}`.trim(),
    `${last} ${first}`.trim(),
    String(user.email ?? '').toLowerCase(),
    userEmploymentId(user).toLowerCase(),
    String(user.current_vehicle_registration ?? '').toLowerCase(),
    String(user.organization_name ?? '').toLowerCase(),
    ...extra.map((part) => part.toLowerCase()),
  ].join(' ');
  return tokens.every((token) => haystack.includes(token));
}

export function userSelectLabel(user: UserSearchFields & { email?: string | null }): string {
  const name = [user.first_name ?? user.firstName, user.last_name ?? user.lastName]
    .map((part) => (part ?? '').trim())
    .filter(Boolean)
    .join(' ')
    || String(user.email ?? '').trim()
    || '';
  const emp = userEmploymentId(user);
  return emp ? `${name} · ${emp}` : name;
}
